'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
    NEED_ACTIVE: 'Ihr Konto {{account}} verwendet diese Website zum ersten Mal. Bitte {{activeLink}}, um die Aktivierung abzuschließen und zu dieser Seite zurückzukehren, um den Vorgang fortzusetzen',
    GOTO_ACTIVE: 'Jetzt Aktivieren',
    NOT_ACTIVED: 'Das Konto wurde nicht erfolgreich aktiviert. Bitte {{activeLink}}, um die Aktivierung abzuschließen',
    COMPLETE_ACTIVE: 'Aktivierung bestätigen',
    FORBID_ACTIVE: 'Das Konto wird in AliExpress nicht unterstützt!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Bitte melden Sie sich mit einem anderen Konto an',
    ACTIVE_PAGE: 'Besuchen Sie die Kontoaktivierungsseite'
};